import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    tituloPrincipal: {
      fontFamily: 'Roboto',
      fontStyle: "normal",
      fontWeight: 700,
      fontSize: "16px",
      lineHeight: "16px",
      textAlign: "center",
      color: "#FFFFFF",
      background: "#205690",
      borderRadius: '7px',
      width:'95%',
      padding: '8px 0px'
    },
    divider: {
        padding: '5px',
        background: '#205690',
        marginBottom: '1rem',
        marginTop: (props) => props.showButton ? '1rem' : 0,
    },
    icon: {
      display: 'block',
      width: "65px",
      height: "65px",
    },
  }));